import { render } from "./loading.vue?vue&type=template&id=9a9ddffa"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=9a9ddffa&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__